module.exports = "/images/Ideris.png?e2a49a90848a95ebc1cb7ec51e633623";